export default {
  choose_place: 'Choose a place',
  pick_up_drop_off: 'Pick-up & Drop-off',
  enter_information: 'Enter information',
  available: 'Available',
  not_available: 'Not available',
  selected: 'Selected',
  seat: 'Seat',
  total: 'Total',
  continue: 'Continue',
  pick_up: 'Pick-up point',
  drop_off: 'Drop-off point',
  seat_empty: 'Please select at least one seat',
  note_placeholder: 'Other requests',
  seats_error: 'Please select at least one seat',
  pick_up_error: 'You have not selected a pick-up point',
  drop_off_error: 'You have not selected a drop off point',
  seats_limit: 'Only a maximum of 10 tickets can be booked per phone number',
  name_error: 'Invalid full name',
  phone_error: 'Invalid phone',
  email_error: 'Invalid email',
  transaction_information: 'Transaction information',
  pick_up_expected: 'Pick-up point (expected)',
  pick_up_1: 'Pick-up point',
  drop_off_expected: 'Drop-off point (expected)',
  drop_off_1: 'Drop-off point',
  vehicle_type: 'Vehicle type',
  vehicle_name: 'Vehicle name',
  trip_information: 'Trip information',
  complete_payment: 'Complete payment',
  complete_booking: 'Complete booking',
  payment_bank_card: 'Payment via bank card (ATM)',
  direct_payment: 'Direct payment',
  payment_methods: 'Payment methods',
  remaining_payment: 'Remaining payment time',
  fare: 'Fare',
  payment_note: 'If you have any other requirements, please enter your message here so we can serve you better!',
  payment_direct: 'You will pay cash to the staff at our office',
  payment_atm: 'Please transfer money to the bank account below',
  mb: 'Military Commercial Joint Stock Bank',
  account_number: 'Account number',
  account_holder: 'Account holder',
  status: 'Status',
  successful_booking: 'Successful booking',
  payment_success: 'Payment success',
  time: 'Time',
  order_code: 'Order code',
  cancellation_tickets: 'Cancellation of tickets',
  policy: 'Policy',
  cancel_refunds: 'Order Cancellation & Refunds',
  payment_notification: 'We have sent trip information to email {mail}, please check carefully!',
  load_data: 'Loading trip information...',
  cancel_title: 'Ticket cancellation information',
  cancel_note: 'I cancel my booking because',
  cancel_submit: 'Cancel booking',
  back: 'Back',
  cancels: [
    {
      id: 1,
      value: 'I have my own personal affairs'
    },
    {
      id: 2,
      value: 'I accidentally bought ticket for wrong time / wrong date'
    },
    {
      id: 3,
      value: 'I accidentally bought the wrong ticket (wrong journey)'
    },
    {
      id: 4,
      value: 'Bus does not have amenities as described on Website'
    },
    {
      id: 5,
      value: 'My desired pick-up point is not accepted by Bus Operator'
    },
    {
      id: 6,
      value: 'Health force majeure'
    },
    {
      id: 7,
      value: 'Other'
    }
  ],
  cancellation_reason_other: 'Please type the reason of cancellation',
  select_reason: 'Please select a reason to cancel',
  enter_reason: 'Please enter a reason',
  ticket_cancel: 'Tickets have been cancelled',
  payment_success_note: 'Please make payment for your booking code <strong>{booking_code}</strong> before <strong>{booking_time}</strong>.<br>' +
      'After this time, unpaid booking will be automatically cancelled.',
  route: 'Route',
  ticket_wrong: 'Ticket information is incorrect. Please try again!',
  cancel_note_common: 'Cancellation fee is calculated on the original price and does not exceed your' +
      ' paid amount (the original price excludes coupons). The travel insurance is non-refundable.',
  min_customer_error: 'Please choose at least {min} seats with this pick up location',
  min_customer_note: 'Only pick up from {min} guests or more',
  maximum_seat: 'You can only select 8 seats each trip',
  unfixed_point: 'Please enter a specific address',
  unfixed_point_validate: 'Please enter a address',
  choose_place_note: 'This trip do not allow to select seats online',
  surcharge_note_1: ' (Surcharge {price}đ/person',
  surcharge_note_2: ', The garage will be collected later)',
  ticket_not_able_cancel: 'Ticket is not able to cancel!',
  cancellation_fee: 'Cancellation fee',
  cancellation_sure: 'Are you sure you want to cancel?',
  bank_address_label: 'Bank address',
  bank_address: 'No 18, Le Van Luong street, Ha Noi city, Vietnam.',
  pay_now: 'Pay now',
  pay_info: 'Confirm ticket information',
  total_refund: 'Total refund',
  cancel_note_1: 'We will contact you as soon as possible in 1 working day or please contact us via Email: hoianbusbooking@gmail.com. Thank you very much.',
}
